<template>
    <div class="making-our-brand-tangible-section" :data-shape-id="shapeId" ref="sectionWrapper">
        <div class="wrapper wrapper-medium">
            <div class="section-copy">
                <div class="overline">Making Our Brand Tangible</div>
                <h2 class="major-heading">
                    {{ headline }}
                </h2>
                <p>
                    {{ copy }}
                </p>
            </div>
            <div class="section-visual">
                <div class="image-wrapper">
                    <div class="video-thumbnail">
                        <img :src="getImgUrl(vimeoCoverImg)" />
                    </div>
                    <!--
                    <div class="cookie-consent" :class="{ 'is-visible': !cookieSettings.vimeo }">
                        <div class="cookie-consent-message">
                            <p>
                                You need to accept cookies set by Vimeo to see this video.<br />
                                Find out more in our <router-link to="/privacy-policy">privacy policy</router-link>.
                            </p>
                        </div>
                    </div>
                    -->
                    <div class="button-container" v-show="!isVideoPlaying">
                        <!--
                        <button-icon
                            icon="play"
                            @click.native="toggleVideo"
                            needsConsent
                            :hasValidConsent="cookieSettings.vimeo"
                            hasPulseEffect
                        />-->
                        <button-icon icon="play" @click.native="toggleVideo" hasPulseEffect />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ButtonIcon from '../../patterns/buttons/ButtonIcon.vue';

    export default {
        name: 'MakingOurBrandTangibleSection',
        data() {
            return {
                includeIframe: true,
                isVideoPlaying: false,
            };
        },
        components: { ButtonIcon },
        props: ['headline', 'copy', 'shapeId', 'vimeoId', 'vimeoCoverImg', 'buttonIcon', 'sectionName'],
        computed: {
            cookieSettings() {
                return this.$store.getters.cookieSettings;
            },
        },
        methods: {
            getImgUrl(fileName) {
                return require('../../../assets/jpg/' + fileName + '.jpg');
            },
            toggleVideo() {
                this.$store.dispatch('toggleVideoModal');
                this.$store.dispatch('updateActiveVideoId', this.vimeoId);
                /*
                if (this.cookieSettings.vimeo) {
                    this.$store.dispatch('toggleVideoModal');
                    this.$store.dispatch('updateActiveVideoId', this.vimeoId);
                } else {
                    const newCookieSettings = this.$cookies.get('cookieSettings');
                    newCookieSettings.vimeo = true;
                    newCookieSettings.showBar = false;
                    this.$cookies.set('cookieSettings', newCookieSettings, '1m');
                    this.$store.dispatch('updateCookieSettings', newCookieSettings);
                }*/
            },
        },
    };
</script>

<style lang="scss" scoped>
    .making-our-brand-tangible-section {
        &.active {
            .section-copy {
                animation: anim-fade-in 1s 0.7s forwards;
            }

            .section-visual {
                animation: anim-fade-in-from-bottom 1s 0.9s forwards;
            }
        }

        &.on-leave {
            .section-copy,
            .section-visual {
                animation: anim-fade-out 0.3s forwards;
            }
        }

        .wrapper {
            @include flex($align-items: center);
        }

        .section-copy {
            width: 50%;
            @include border-box();
            z-index: 1;
            position: relative;
            opacity: 0;
            box-sizing: border-box;
            padding-right: 50px;

            @media (max-width: breakpoint('medium')) {
                width: 100%;
                text-align: center;
                padding-right: 0px;
            }
        }

        @media (max-width: breakpoint('extra-small')) {
            margin-top: spacing(10);
        }
    }

    .section-visual {
        width: 50%;
        opacity: 0;

        @media (max-width: breakpoint('medium')) {
            width: 100%;
            margin-top: 30px;
        }

        .image-wrapper {
            position: relative;
            width: 150%;
            height: auto;
            display: block;
            box-shadow: box-shadow('big');

            @media (max-width: breakpoint('extra-large') + 300) {
                width: 125%;
            }

            @media (max-width: breakpoint('extra-large')) {
                width: 100%;
            }

            .cookie-consent {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background: rgba(0, 0, 0, 0.75);
                color: #ffffff;
                padding: 0 40px;
                box-sizing: border-box;
                opacity: 0;
                pointer-events: none;
                transition: opacity 0.3s;

                &.is-visible {
                    opacity: 1;
                    pointer-events: all;
                }

                @media (max-width: breakpoint('small')) {
                    padding: 0 20px;
                }

                .cookie-consent-message {
                    position: relative;
                    top: 50%;
                    transform: translateY(-50%);
                    text-align: center;
                }

                a {
                    color: color('magenta');
                    font-weight: font-weight(bold);
                    text-underline-position: under;
                }
            }

            .video-thumbnail {
                padding-top: 56.25%;
                width: 100%;
            }

            img {
                position: absolute;
                top: 0;
                left: 0;
                height: 100%;
                width: 100%;
            }

            .button-container {
                position: absolute;
                bottom: 0;
                transform: translateY(50%);
                left: 15%;
                z-index: 1;
            }
        }
    }

    @media (max-width: breakpoint('extra-small')) {
        .overline {
            display: none;

            & + .major-heading {
                margin-top: 0;
            }
        }
    }

    /* TODO globalize and bundle all keyframe anim in global SCSS */

    @keyframes anim-fade-in {
        from {
            transform: translateX(-20px);
            opacity: 0;
        }

        to {
            transform: translateX(0px);
            opacity: 1;
        }
    }

    @keyframes anim-fade-in-from-bottom {
        from {
            transform: translateY(20px);
            opacity: 0;
        }

        to {
            transform: translateY(0px);
            opacity: 1;
        }
    }

    @keyframes anim-fade-out {
        from {
            transform: translateY(0px);
            opacity: 1;
        }

        to {
            transform: translateY(20px);
            opacity: 0;
        }
    }

    @keyframes anim-fade-out-to-bottom {
        from {
            transform: translateY(0px);
            opacity: 1;
        }

        to {
            transform: translateY(20px);
            opacity: 0;
        }
    }
</style>
